import { useEffect, useState } from "react";
import { useNotices } from "../contexts/NoticeContext";
import { X } from "lucide-react"; // ✅ lucide-react 아이콘 사용

export default function NoticePopup() {
  const { notices } = useNotices();
  const [visible, setVisible] = useState(false);
  const [popupNotice, setPopupNotice] = useState<any>(null);

  useEffect(() => {
    if (!notices.length) return;
    const latestPopup = notices.find((n: any) => n.is_popup);
    if (!latestPopup) return;

    const dismissed = localStorage.getItem(`notice_${latestPopup.id}_dismissed`);
    if (!dismissed) {
      setPopupNotice(latestPopup);
      setVisible(true);
    }
  }, [notices]);

  const handleClose = () => {
    if (popupNotice) {
      localStorage.setItem(`notice_${popupNotice.id}_dismissed`, "true");
    }
    // 간단한 fade-out 애니메이션
    setVisible(false);
  };

  if (!popupNotice) return null;

  return (
    <div
      className={`fixed inset-0 bg-black/60 flex items-center justify-center z-[9999] sm:p-4 transition-opacity duration-300 ${
        visible ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <div
        className={`
          bg-white text-gray-800 shadow-2xl
          rounded-t-2xl sm:rounded-2xl
          w-full sm:max-w-md sm:w-auto
          p-5 sm:p-6
          fixed sm:relative bottom-0 sm:bottom-auto
          transition-transform duration-300
          ${visible ? "translate-y-0 sm:scale-100" : "translate-y-full sm:scale-95"}
        `}
      >
        {/* 닫기 X 버튼 */}
        <button
          onClick={handleClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-black transition"
          aria-label="닫기"
        >
          <X size={20} />
        </button>

        {/* 제목 */}
        <h2 className="text-base sm:text-lg font-semibold mb-3 text-center sm:text-left">
          {popupNotice.title}
        </h2>

        {/* 내용 */}
        <div
          className="text-sm sm:text-base text-gray-700 leading-relaxed whitespace-pre-line text-center sm:text-left max-h-[60vh] overflow-y-auto"
          dangerouslySetInnerHTML={{ __html: popupNotice.content }}
        />

        {/* 닫기 버튼 (모바일용 하단 배치) */}
        <div className="text-center mt-5 sm:mt-6">
          <button
            onClick={handleClose}
            className="bg-gray-800 text-white rounded-lg px-5 py-2 text-sm hover:bg-gray-700 w-full sm:w-auto"
          >
            닫기
          </button>
        </div>
      </div>
    </div>
  );
}
